import { Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { geoActions } from '../../core/ngrx/actions';
import { AvailabilityZoneHandler, AvailabilityZone } from '../../core/service/availability-zone.handler';
import { Subject } from 'rxjs';
import { takeUntil, take } from 'rxjs/operators';

interface MWTotals {
  live: number;
  uc: number;
  planned: number;
  total: number;
}

@Component({
    selector: 'app-availability-zone-popup',
    templateUrl: './availability-zone-popup.component.html',
    styleUrls: ['./availability-zone-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AvailabilityZonePopupComponent implements OnInit, OnDestroy {
  @Input() provider: string;
  @Input() availabilityZoneId: string;

  public datacenters: AvailabilityZone[] = [];
  public mwTotals: MWTotals = {
    live: 0,
    uc: 0,
    planned: 0,
    total: 0
  };

  private destroy$ = new Subject<void>();

  constructor(
    private store: Store,
    private cd: ChangeDetectorRef,
    private availabilityZoneHandler: AvailabilityZoneHandler
  ) {}

  ngOnInit() {
    this.loadDatacenters();
  }

  private loadDatacenters() {
    this.datacenters = this.availabilityZoneHandler.getDatacentersByAzId(this.availabilityZoneId);
    this.calculateTotals();
    this.cd.detectChanges();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private calculateTotals() {
    this.resetTotals();

    this.datacenters.forEach(dc => {
      this.mwTotals.live += dc.mwLive || 0;
      this.mwTotals.uc += dc.mwUC || 0;
      this.mwTotals.planned += dc.mwPlanned || 0;
    });

    this.mwTotals.total = this.mwTotals.live + this.mwTotals.uc + this.mwTotals.planned;
  }

  private resetTotals(): void {
    Object.keys(this.mwTotals).forEach(key => {
      this.mwTotals[key] = 0;
    });
  }

  zoomToDatacenter(datacenter: AvailabilityZone) {
    this.store.dispatch(geoActions.centerMap({
      info: {
        id: datacenter.id?.toString() || '',
        name: datacenter.provider,
        desc: datacenter.availabilityZoneId || '',
        latitude: datacenter.lat,
        longitude: datacenter.lon,
        zoom: 12
      }
    }));
  }
}
